import { css } from 'styled-components';
export const rawLinkEffect = ({ theme }) => css `
  color: ${theme.colors.link};
  font-weight: ${theme.fontWeights[1]};
  text-decoration: underline;
  text-decoration-thickness: 2px;
`;
//# sourceMappingURL=rawLinkEffect.js.map